var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"button",class:{ loading: _vm.state == 'loading' },attrs:{"id":_vm.id},on:{"click":function($event){return _vm.onClick()}}},[_vm._t("default",function(){return [_vm._v("Button")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }